import {createTheme} from "@mui/material";
import {mainTheme} from "./main-theme";

export const loginTheme = createTheme(mainTheme, {
  components: {
    MuiTextField: {
      defaultProps: {
        margin: 'normal',
        fullWidth: true,
        required: true,
        variant: 'outlined',
      },
    },
    MuiButton: {
      defaultProps: {
        fullWidth: true,
        variant: 'contained',
      },
      styleOverrides: {
        root: {
          height: '3rem',
          marginTop: '1rem',
        }
      }
    }
  }
});